import { render, staticRenderFns } from "./BrandImage.vue?vue&type=template&id=02fb7141&"
import script from "./BrandImage.vue?vue&type=script&lang=ts&"
export * from "./BrandImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports